"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userChildrenController = function () {
  function userChildrenController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userChildrenController);
  }

  (0, _createClass3.default)(userChildrenController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.children,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Children."
        },
        columns: [{ field: "firstName", title: "First Name", filterable: false, width: "6rem" }, { field: "lastName", title: "Last Name", filterable: false, width: "6rem" }, { field: "dateOfBirth", title: "Date of Birth", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(dateOfBirth), 'dd-MM-yyyy') #" }, { field: "gender", title: "Gender", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getGenderText(dataItem.gender);
          } }, { field: "allergyDetails", title: "Allergy Details", filterable: false, width: "6rem" }, { field: "aboutMe", title: "More Details", filterable: false, width: "6rem" }]
      };
    }
  }, {
    key: "_getGenderText",
    value: function _getGenderText(gender) {
      switch (gender) {
        case _constants2.default.gender.MALE:
          return "Male";
        case _constants2.default.gender.FEMALE:
          return "Female";
        case _constants2.default.gender.UNSPECIFIED:
          return "-";

      }
    }
  }]);
  return userChildrenController;
}();

exports.default = userChildrenController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-children/user-children.controller.js
 **/